import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import QRCode from 'qrcode';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from 'react-router-dom';

const QrCodeGenerator = () => {
  const [text, setText] = useState('');
  const [qrUrl, setQrUrl] = useState('');
  const [error, setError] = useState('');
  const [size, setSize] = useState(300);
  const [fgColor, setFgColor] = useState('#000000');
  const [bgColor, setBgColor] = useState('#ffffff');
  const [label, setLabel] = useState('');
  const [pageContent, setPageContent] = useState('');

  const location = useLocation();
  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    if (paramlink) {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
      } catch (err) {
        console.error('Error fetching page content:', err);
      }
    }
  };

  const generateQRCode = async () => {
    if (!text.trim()) {
      setError('Please enter text to generate QR Code');
      setQrUrl('');
      return;
    }
    try {
      const url = await QRCode.toDataURL(text, {
        width: size,
        color: { dark: fgColor, light: bgColor },
      });
      setQrUrl(url);
      setError('');
    } catch {
      setError('Error generating QR Code');
      setQrUrl('');
    }
  };

  const handleClear = () => {
    setText('');
    setQrUrl('');
    setError('');
    setLabel('');
    setSize(300);
    setFgColor('#000000');
    setBgColor('#ffffff');
  };

  return (
    <>
      <Header />
      <RandomContent />

      {/* Page Intro (Section 1) */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div
                className="single-blog-inner shadow-sm p-4 mb-4"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                <div className="details">
                  <h4><a href="#">{pageContent?.section1header}</a></h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageContent?.section1text && pageContent.section1text.trim() !== ""
                        ? pageContent.section1text
                        : `Create customizable QR Codes instantly. Add optional text below, change colors and size, and scan directly from the screen! 🚀`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QR Generator Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-6 col-md-8">
              <div className="single-blog-inner p-5 shadow-lg rounded-3" data-aos="fade-up" data-aos-duration="2800">

                {/* Text Input */}
                <div className="mb-3">
                  <label className="form-label">Enter Text or URL</label>
                  <input
                    type="text"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    value={text}
                    placeholder="Enter text or URL"
                    onChange={(e) => { setText(e.target.value); setError(''); }}
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </div>

                {/* Optional Label */}
                <div className="mb-3">
                  <label className="form-label">Optional Text Below QR</label>
                  <input
                    type="text"
                    className="form-control"
                    value={label}
                    placeholder="Enter text to show below QR (optional)"
                    onChange={(e) => setLabel(e.target.value)}
                  />
                </div>

                {/* Customization Options */}
                <div className="mb-3 d-flex gap-2 flex-wrap">
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Size (px)</label>
                    <input
                      type="number"
                      className="form-control"
                      min="100"
                      max="800"
                      value={size}
                      onChange={(e) => setSize(parseInt(e.target.value) || 300)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Foreground Color</label>
                    <input
                      type="color"
                      className="form-control form-control-color"
                      value={fgColor}
                      onChange={(e) => setFgColor(e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Background Color</label>
                    <input
                      type="color"
                      className="form-control form-control-color"
                      value={bgColor}
                      onChange={(e) => setBgColor(e.target.value)}
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mb-3">
                  <button className="default-btn icon four" onClick={generateQRCode}>Generate QR</button>
                  <button className="default-btn icon outline" onClick={handleClear}>Clear</button>
                </div>

                {/* QR Output */}
                {qrUrl && (
                  <div className="text-center mt-4">
                    <div className="qr-wrapper p-3 rounded shadow-sm" style={{ display: 'inline-block', backgroundColor: bgColor }}>
                      <img
                        src={qrUrl}
                        alt="Generated QR Code"
                        className="img-fluid"
                        style={{ width: `${size}px`, height: `${size}px` }}
                      />
                      {label && <div className="qr-label mt-2" style={{ fontWeight: 600, fontSize: '1.1rem' }}>{label}</div>}
                    </div>
                    <div className="mt-3">
                      <a href={qrUrl} download="qr-code.png" className="default-btn icon outline">
                        Download QR
                      </a>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 Below Boxes */}
      {pageContent?.section2text && pageContent.section2text.trim() !== "" && (
        <div className="blog-area">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageContent.section2text,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />

      <style jsx>{`
        .form-label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        .d-flex button {
          flex: 1;
        }
        .qr-wrapper {
          transition: transform 0.2s;
        }
        .qr-wrapper:hover {
          transform: scale(1.05);
        }
        @media(max-width: 576px) {
          .d-flex, .d-flex > div {
            flex-direction: column !important;
            margin-bottom: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default QrCodeGenerator;
